import { Provider } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NERA_TRANSLATOR } from 'nera-common/angular';

/**
 * The translator port `nera-common/angular` uses.
 *
 * The shared Angular components (the dynamic table, the metric error panel)
 * live in the library and may not depend on Transloco — they translate
 * through this port instead. The app binds Transloco to it once, so the
 * components render the same strings they always did.
 *
 * Extracted from `provideAuth()` (which also binds the auth/toast ports) so
 * a unit test that renders a shared component can bind the same port without
 * pulling in the whole auth provider.
 */
export const provideNeraI18n = (): Provider[] => [
    {
        provide: NERA_TRANSLATOR,
        useFactory: (transloco: TranslocoService) => ({
            translate: (key: string, params?: Record<string, unknown>) =>
                transloco.translate(key, params),
            getActiveLang: () => transloco.getActiveLang(),
        }),
        deps: [TranslocoService],
    },
];
